<script>
import formatPrice from "@utils/format-price";
import formatCurrency from "@utils/format-currency";
import formatOrderPrepaid from "@utils/format-order-prepaid";
import {
  prepaidFormatExpiredDate,
  prepaidFormatUsedTimes,
  prepaidIsExpired,
} from "@utils/ipetbooking-prepaid";

const DEFAULT_ITEM = {
  "id": "prepaidorder",
  "status": -1,
  "basePrice": 900,
  "total": 800,
  "times": 4,
  "used": 1,
  "created": "2021-07-10 21:42:43",
  "paidDate": "2021-07-08 21:48:19",
  "cancelDate": null,
  "paymentExpiredDate": "2021-08-20 23:59:59",
  "paymentMethod": null,
  "expiredDate": "2021-08-25",
  "prepaid": {
    "title": "迷你犬包套皮毛管理",
    "alias": "mini-dog-a",
    "image": "https://assets.codepen.io/1759070/plan-1%402x.png",
    "stores": [
      {
        "title": "台北店",
        "alias": "taipei",
        "storeType": "store",
        "state": 0
      }
    ],
    "applicableEvents": [],
    "expireDays": 30
  },
}
export default {
  props: {
    orderItem: {
      type: Object,
      default: () => {
        return DEFAULT_ITEM
      },
    },
  },
  methods: {
    formatPrice,
    formatCurrency,
    formatOrderPrepaid,
    prepaidFormatExpiredDate,
    prepaidIsExpired,
    formatUsedTimesText(item) {
      return item.times - item.used > 0
        ? `${prepaidFormatUsedTimes(item.times - item.used)}/${prepaidFormatUsedTimes(item.times)}`
        : '使用完畢';
    },
  }
}
</script>
<template>
  <div :class="$style.orderList">
    <div
      class="orderList__item"
    >
      <div class="orderList__imageBox">
        <div class="orderList__image">
          <div
            class="orderList__imageInner"
            :style="{ backgroundImage: `url('${ orderItem.prepaid.image || require('@assets/images/default/plan-default-Image@2x.png') }')` }"
          >
          </div>
        </div>
      </div>
      <div class="orderList__infoBox">
        <div class="d-flex align-items-center flex-wrap">
          <BaseStoreTagList
            :store-list="orderItem.stores"
          />
        </div>
        <div class="orderList__title">
          {{ orderItem.prepaid.title }}
          <div v-if="$globalCategoryVisible" class="orderList__category">
            <i :class="`fontello ${$globalIsDingBeauty ? 'fontello-db-lipstick' : 'fontello-paw'} fa-fw mr-2 text-gray-3`"></i><span>{{ orderItem.prepaid.categoryTitle }} | {{ orderItem.prepaid.sizeTitle }}</span>
          </div>
        </div>
        <div class="orderList__slogan">
          {{ orderItem.prepaid.slogan }}
        </div>
        <div class="orderList__meta" :class="{ 'prepaidIsExpired': prepaidIsExpired(orderItem.expiredDate) }">
          <span>使用期限：</span>
          <span>{{ prepaidFormatExpiredDate(orderItem) }}</span>
          <span v-if="prepaidIsExpired(orderItem.expiredDate)">(已過期)</span>
        </div>
        <div class="orderList__times">
          <span v-if="orderItem.times - orderItem.used > 0" class="mr-2">剩餘抵用次數</span>
          <span class="text-primary font-number">{{ formatUsedTimesText(orderItem) }}</span>
        </div>
      </div>
      <div class="orderList__actionBox">
        <div>
          <div
            class="orderList__price"
          >
            {{ formatPrice(orderItem.price) }}
          </div>
          <div
            v-if="orderItem.price < orderItem.basePrice"
            class="orderList__basePrice text-decoration-line-through"
          >
            原價 NT${{ formatCurrency(orderItem.basePrice) }}
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<style lang="scss" module>
.listPrepaidOrderJtails {
  :global {
    .listPrepaidOrderJtails {
      @include unstyled;
    }
  }
}

.orderList {
  @include list-unstyled;

  margin-bottom: 3rem;
  
  :global {
    .orderList {
      &__item {
        display: flex;
        flex-wrap: wrap;
        padding: 1.5rem;
        border: 1px solid #C6C6BB;
        transition: border-color 0.3s;

        &:not(:last-child) {
          margin-bottom: 1.875rem;
        }

        &.isActive {
          background: rgba($color-primary, 0.05);
          border-color: $color-primary-dark;
        }

        @include max-lg {
          display: grid;
          grid-template-rows: auto;
          grid-template-columns: 220px auto;
        }

        @include max-md {
          grid-template-columns: auto 0;
        }
      }

      &__imageBox {
        flex-shrink: 0;
        width: 220px;

        @include max-lg {
          grid-row: 1 / 3;
          width: auto;
        }

        @include max-md {
          grid-row: 1;
          grid-column: 1 / 3;
        }
      }

      &__infoBox {
        flex: 1;
        width: calc(100% - 420px);
        padding-left: 1.5rem;

        @include max-lg {
          grid-column: 2 / 3;
          width: auto;
        }

        @include max-md {
          grid-row: 2 / 3;
          grid-column: 1;
          padding: 0;
          margin-top: 1.5rem;
        }
      }

      &__actionBox {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        align-items: flex-end;
        justify-content: space-between;
        width: 200px;
        text-align: right;

        @include max-lg {
          grid-row: 2 / 3;
          grid-column: 2 / 3;
          width: auto;
          margin-top: 1rem;
        }

        @include max-md {
          grid-row: 2 / 3;
          grid-column: 1;
          justify-content: end;
        }
      }

      &__price {
        margin-bottom: 0.25rem;
        font-family: $font-number;
        font-size: 1.25rem;
        font-weight: 600;
        color: $color-primary;
        text-align: right;

        @include max-md {
          margin-bottom: 0;
          text-align: left;
        }
      }

      &__basePrice {
        font-family: $font-number;
        font-size: 0.875rem;
        color: #B9B9B9;
        text-align: right;
        letter-spacing: 0.1em;

        @include max-md {
          text-align: left;
        }
      }

      &__image {
        position: relative;
        display: block;
        padding-top: 73%;
        overflow: hidden;
      }

      &__imageInner {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
        transition: transform 0.3s;
        transform: scale(1);
      }

      &__title {
        margin-bottom: 0.5rem;
        font-family: $font-serif;
        font-size: 1.25rem;
        font-weight: 600;
        color: $color-primary-dark;
      }

      &__category {
        margin-bottom: 0.5rem;
        font-size: 0.875rem;
      }

      &__slogan {
        min-height: 1.875rem;
        margin-bottom: 0.25rem;
        font-size: 0.875rem;
        line-height: 1.75;
      }

      &__meta {
        margin-bottom: 0.25rem;
        font-size: 0.75rem;
        line-height: 1.75;

        &.prepaidIsExpired {
          color: $color-danger;
        }
      }

      &__times {
        display: inline-block;
        padding: 0.25rem 2rem;
        font-size: 0.875rem;
        border: 1px solid #C6C6BA;
      }
    }
  }
}
</style>
